var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", { attrs: { title: "Fabric Test" } }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-10", attrs: { cols: "12" } },
            [
              _c("canvas", {
                staticStyle: { border: "1px solid #ccc" },
                attrs: { id: "c", width: "500", height: "300" },
              }),
              _c(
                "v-col",
                { staticClass: "ma-0 pa-3", attrs: { cols: "12" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-0 pb-2",
                      attrs: { cols: "12", align: "left" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            "cols = " +
                              _vm.canvasWidth +
                              ", rows = " +
                              _vm.canvasHeight
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm._l(_vm.objectList, function (item, index) {
                    return _c(
                      "v-col",
                      {
                        key: index,
                        staticClass: "ma-0 pa-0",
                        attrs: { cols: "12", align: "left" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              "Object " +
                                index +
                                " > " +
                                "xmin = " +
                                item.left +
                                ", xmax = " +
                                item.width +
                                ", ymin = " +
                                item.top +
                                ", ymax = " +
                                item.height
                            ) +
                            " "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }